<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="hub/person-nationality/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { PersonNationality } from '@/modules/hub/data/person-nationality/create'
	import { PersonNationalityService } from '@/modules/hub/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return PersonNationality;
			},

			service()
			{
				return new PersonNationalityService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>